module.exports = __webpack_public_path__ + "static/media/innovation-mob-header.1ea57cb1.svg";